module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getReportsHistory()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonReadHistory[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelHistoryLength[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.historyLength),
      expression: "historyLength"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.historyLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.historyLength = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.reportsIsReading) ? _c('spinner') : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col04[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reportsList), function(report, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(report.report_id))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, _vm._l((report.linked_commissions), function(transaction) {
      return _c('p', [_vm._v(_vm._s(transaction.transactionId))])
    }), 0), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('h6', [_vm._v(_vm._s(_vm.labelInvoiceAmount[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(report.total_amount) + " $")]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelInvoiceReferenceNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (report.invoice_reference_number),
        expression: "report.invoice_reference_number"
      }],
      staticClass: "form-control align-center push",
      attrs: {
        "type": "test",
        "placeholder": ""
      },
      domProps: {
        "value": (report.invoice_reference_number)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(report, "invoice_reference_number", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs align-center",
      attrs: {
        "type": "button",
        "name": "buttonAddPlanItem"
      },
      on: {
        "click": function($event) {
          return _vm.saveReportReferenceNumber(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-floppy-o fa-1x push-5-r "
    }), _vm._v(_vm._s(_vm.labelButtonInvoiceReferenceNumber[_vm.actualLanguage]))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(report.payment_done_by_evsens) ? _c('i', {
      staticClass: "fa fa-check-square"
    }) : _c('i', {
      staticClass: "fa fa-times"
    }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.labelInvoiceReferenceNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(report.payment_reference_number))])])])
  }), 0)])])])], 1)])])]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51a1b11d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/Integrator/IntegratorCommissionsReports.vue
// module id = 1532
// module chunks = 4